import { Role } from '../helpers/role';
import { castIdRouteParams } from '../helpers/helpers';

export default [
    {
        path: '/proposals/thematicarea',
        name: 'thematicAreaProposal',
        component: () => import('../views/proposals/ThematicAreaProposal.vue'),
        meta: {  claims: [{ name: 'registers', crud: 'read' }, { name: 'nijEmployee', crud: 'read' }]}
    }
]
